
import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, PerspectiveCamera, Stars, ContactShadows } from '@react-three/drei';
import { Tree } from './components/Tree';
import { Snow } from './components/Snow';

const App: React.FC = () => {
  return (
    <div className="relative h-screen w-screen bg-[#020408] overflow-hidden select-none">
      {/* 3D Canvas */}
      <div className="absolute inset-0 z-0">
        <Canvas shadows dpr={[1, 2]} gl={{ antialias: true }}>
          <PerspectiveCamera makeDefault position={[0, 6, 16]} fov={40} />
          
          <Stars radius={100} depth={50} count={3000} factor={4} saturation={0} fade speed={1} />
          
          {/* 使用 HemisphereLight 模拟大气散射的底色 */}
          <hemisphereLight intensity={0.5} color="#112244" groundColor="#000000" />
          
          {/* 主环境光 */}
          <ambientLight intensity={0.6} color="#fff4e0" />
          
          {/* 模拟月光的强方向光 */}
          <directionalLight 
            position={[5, 10, 5]} 
            intensity={1.2} 
            color="#aaccff" 
            castShadow 
            shadow-mapSize={[1024, 1024]}
          />

          {/* 聚光灯：照亮树的主体 */}
          <spotLight 
            position={[10, 20, 10]} 
            angle={0.3} 
            penumbra={1} 
            intensity={15} 
            color="#ffffff"
            castShadow 
          />
          
          {/* 移除 Environment 组件，避免网络请求阻塞渲染 */}
          <Suspense fallback={null}>
            <Tree />
            <Snow />
            <ContactShadows 
              resolution={1024} 
              scale={30} 
              blur={1.5} 
              opacity={0.5} 
              far={15} 
              color="#000000" 
              position={[0, -0.01, 0]}
            />
          </Suspense>

          <OrbitControls 
            enablePan={false} 
            minPolarAngle={Math.PI / 6} 
            maxPolarAngle={Math.PI / 1.9} 
            minDistance={8}
            maxDistance={25}
            autoRotate
            autoRotateSpeed={0.4}
            enableDamping
            dampingFactor={0.05}
            target={[0, 2.8, 0]}
          />
        </Canvas>
      </div>

      {/* Instructions */}
      <div className="absolute bottom-8 right-8 text-white/30 text-[10px] uppercase tracking-widest hidden md:block">
        滑动交互叶片 • 左键旋转观察
      </div>

      {/* Aesthetic Text Overlay */}
      <div className="absolute bottom-12 left-0 w-full flex justify-center pointer-events-none opacity-90 transition-opacity duration-1000">
        <div className="flex flex-col items-center gap-3">
          <span className="text-white text-2xl tracking-[0.15em] font-extralight drop-shadow-[0_0_15px_rgba(255,255,255,0.6)]">
            2025 圣诞快乐, 我亲爱的奇迹
          </span>
          <div className="h-[1px] w-32 bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
        </div>
      </div>
    </div>
  );
};

export default App;
